
    // this file was auto generated by python script
    // this icon was sourced from feather icons 4.2.8
    import React from 'react';
    const Navigation2 = () => (
      <>
        <polygon points="12 2 19 21 12 17 5 21 12 2"></polygon>
      </>
    );
    export default Navigation2;
    